import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/review';

@Injectable({
  providedIn: 'root'
})
export class GuestsReviewService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/Review/ListGuestsReviews`, filter);
  }
  HideReview(reviewId: any, IsHide: boolean): any {
    return this.http.get(`${environment.apiUrl}/Review/HideReview?reviewId=${reviewId}&IsHide=${IsHide}`);
  }
}
